module.exports = __webpack_public_path__ + "img/uid-token-game-guide.4ce49faa.png";